import { render, staticRenderFns } from "./lrs.vue?vue&type=template&id=5f33356d&"
import script from "./lrs.ts?vue&type=script&lang=ts&"
export * from "./lrs.ts?vue&type=script&lang=ts&"
import style0 from "./lrs.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports